import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { currentPeriod, shiftPeriod } from '../format';
import { periodLabel } from './labels';

/**
 * The month spinner of §9 and §19 — «‹ Октябрь 2022 ›».
 *
 * It is the spec's own control and it is also the right one for a phone: a native
 * `<input type="month">` is unsupported in Firefox (it degrades to a free-text field where
 * «октябрь 2022» is a typo away from a silent 400), and an AntD `DatePicker` would pull
 * `dayjs`'s locale machinery into a bundle whose one hard rule is that it fetches nothing.
 * Two buttons and a label need neither.
 *
 * Forward travel stops at the CURRENT month, because a billing month that has not begun has
 * no charges and no documents by construction — an endless «next» would let a subscriber
 * page into 2031 and conclude the portal had lost his data.
 */
export function MonthSpinner({
  labelKey,
  period,
  onChange,
}: {
  labelKey: string;
  period: string;
  onChange: (period: string) => void;
}) {
  const { t } = useTranslation();
  const atLatest = period >= currentPeriod();

  return (
    <div className="pa-spinner-field">
      <span className="pa-picker-label">{t(labelKey)}</span>
      <div className="pa-spinner-controls">
        <Button
          aria-label={t('money.previousMonth')}
          onClick={() => onChange(shiftPeriod(period, -1))}
        >
          ‹
        </Button>
        <span className="pa-spinner-value">{periodLabel(period, t)}</span>
        <Button
          aria-label={t('money.nextMonth')}
          disabled={atLatest}
          onClick={() => onChange(shiftPeriod(period, 1))}
        >
          ›
        </Button>
      </div>
    </div>
  );
}
